if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.body = document.querySelector("body");

        this.form = this.querySelector("form");
        this.form?.addEventListener("submit", (evt) => {
          evt.preventDefault()
          this.handleSubmit()
        })

        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;

        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer")) {
          this.submitButton?.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      async handleSubmit(oneTimePurchase = false) {
        if (!this.form || this.dataset.locked === "true") return;
        if (!this.submitButton || this.submitButton?.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement?.(document.activeElement);

        this.lock();

        if (!oneTimePurchase) {
          this.enableLoadingInButton();
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
        } else {
          formData.append("sections", "");
        }

        formData.append("sections_url", window.location.pathname);

        if (oneTimePurchase) {
          formData.delete("selling_plan");
        }

        config.body = formData;

        try {
          if (window.GlobalVars.subscriptionWidgetEnabled) {
            // We don't want to mix one-time purchases with subscriptions on direct checkout
            // So we clear the cart before adding the item
            await fetch(routes.cart_clear_url)
          }

          const response = await fetch(routes.cart_add_url, config)
          const data = await response.json()

          if (data.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: data.errors || data.description,
              message: data.message,
            });

            this.handleErrorMessage(data.description);
            this.error = true;

            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");

            this.dispatchEvent(
              new CustomEvent("cart-drawer:refresh", {
                detail: { response: data },
                bubbles: true,
                composed: true,
              }),
            );

            if (!soldOutMessage) return;

            this.submitButton.setAttribute("aria-disabled", "true");
            this.submitButton.querySelector("span")?.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");

            return;
          } else if (window.GlobalVars.subscriptionWidgetEnabled && !oneTimePurchase) {
            // Subscription will be a direct checkout
            window.location = `${routes.root_url}checkout`
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: data,
          });

          this.error = false;

          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.redirectAfterSubmit(data);
                });
              },
              { once: true },
            );

            if (this.cartType === "drawer") quickAddModal.hide(true);
          } else {
            const isClosedCart = !document.body.classList.contains(
              "page-overlay-cart-on",
            );
            this.redirectAfterSubmit(data, isClosedCart);
          }
        } catch (e) {
          console.error(e);

          if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
            location.reload();
          }
        } finally {
          this.cart?.classList.remove("is-empty");
          this.unlock();

          if (this.error) {
            this.disableLoadingInButton();
            return;
          }

          this.hideQuickBuy();

          setTimeout(() => {
            this.disableLoadingInButton();
          }, 200);
        }
      }

      lock() {
        this.dataset.locked = "true";
      }

      unlock() {
        this.dataset.locked = "false";
      }

      enableLoadingInButton() {
        if (!this.submitButton) return;

        this.submitButton.classList.add("loading");
        this.submitButton.setAttribute("aria-disabled", "true");
        this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");
      }

      disableLoadingInButton() {
        if (!this.submitButton) return;

        this.submitButton.classList.remove("loading");
        this.submitButton.setAttribute("aria-disabled", "false");
        this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
      }

      hideQuickBuy() {
        const quickAddContainerEl = document.querySelector(
          ".wt__quick-buy__container",
        );
        const quickAddOverlayEl = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        const quickAddProductEl = quickAddContainerEl?.querySelector(".wt-product");
        const loaderEl = quickAddContainerEl?.querySelector(
          ".wt__quick-buy-loader",
        );

        if (!quickAddContainerEl?.classList.contains("hidden")) {
          quickAddProductEl?.remove();
          quickAddContainerEl?.classList.remove(
            "wt__quick-buy__container--open",
          );
          quickAddOverlayEl?.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
          document.body.classList.remove("quick-buy-page-overlay");
          loaderEl?.classList.remove("hidden");
        }
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        if (globalThis.rebuyAppEmbedEnabled) {
          window.Rebuy?.SmartCart?.show()
          return
        }

        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay?.classList.remove("wt__quick-buy--page-overlay--open");

          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart?.renderContents(response, isClosedCart);
          return;
        }

        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = "") {
        if (this.hideErrors) return;

        const errorMessageWrapperEl = this.querySelector(".product-form__error-message-wrapper");
        if (!errorMessageWrapperEl) return;

        const errorMessageEl = errorMessageWrapperEl.querySelector(".product-form__error-message");
        if (!errorMessageEl) return;

        errorMessageWrapperEl.toggleAttribute("hidden", !errorMessage);
        errorMessageEl.textContent = errorMessage;
      }
    },
  );
}
